<template>
  <v-alert
    v-if="show_notification"
    class="new-version-notification px-5"
    :class="{ 'notification-show': show_notification }"
    elevation="6"
    prominent
    dismissible
    @input="dismissNotification"
  >
    <div class="text-h6 mb-0">App Update Available</div>
    <div class="text-body-2">A new version of the app has been deployed. Please refresh your browser to avoid any issues.</div>

    <v-btn
      class="mt-5 mr-2"
      color="primary"
      @click="refreshApp"
    >
      <v-icon
        aria-hidden="true"
        left
      >mdi-refresh</v-icon>
      Refresh Now
    </v-btn>
  </v-alert>
</template>

<script>
import VersionService from '@/js/HashVersion.js';

export default {
  name: 'NewVersionNotification',

  data() {
    // persist alert across route changes (this component will remount)
    const was_already_showing = sessionStorage.getItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY) === 'true';

    return {
      show_notification: was_already_showing,
    };
  },

  async mounted() {
    this.$rc.$event_bus.$on('new-version-available', this.onNewVersionAvailable);

    const was_already_showing = sessionStorage.getItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY) === 'true';

    if (was_already_showing) {
      this.show_notification = true;
      sessionStorage.setItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY, 'true');
    } else if (VersionService.getIsNewVersionAvailable()) {
      const is_still_new = await VersionService.checkForNewVersion(); // double-check in case it was set while this component was not mounted
      setTimeout(() => {
        this.show_notification = is_still_new;
        if (is_still_new) {
          sessionStorage.setItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY, is_still_new ? 'true' : 'false');
        }
      }, 100);
    } else {
      this.show_notification = false;
      sessionStorage.removeItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY);
    }
  },

  beforeDestroy() {
    this.$rc.$event_bus.$off('new-version-available', this.onNewVersionAvailable);
  },

  methods: {
    onNewVersionAvailable(isAvailable) {
      if (isAvailable) {
        setTimeout(() => {
          this.show_notification = true;
          sessionStorage.setItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY, 'true');
        }, 100);
      } else {
        this.show_notification = false;
        sessionStorage.removeItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY);
      }
    },

    refreshApp() {
      VersionService.refreshToNewVersion();
    },

    dismissNotification() {
      this.show_notification = false;
      VersionService.setIsNewVersionAvailable(false);
      sessionStorage.removeItem(VersionService.STORAGE_KEY_ALERT_VISIBILITY);
    },
  }
};
</script>

<style scoped>
.new-version-notification {
  background-color: rgba(255, 255, 255, 1);
  position: fixed !important;
  top: 20px;
  right: 20px;
  z-index: 199;
  max-width: 450px;
  min-width: 350px;
  transform: translateX(470px);
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

:deep(.v-alert__dismissible.v-btn.v-btn--icon) {
  align-self: start;
  transform: translateY(.5rem);
}

.notification-show {
  transform: translateX(0);
  opacity: 1;
}

@media (max-width: 600px) {
  .new-version-notification {
    left: 16px !important;
    right: 16px !important;
    top: 16px;
    max-width: none;
    min-width: 0;
    transform: translateY(-120px);
  }

  .notification-show {
    transform: translateY(0);
  }
}
</style>
